export enum UserFeedHealthStatus {
  Ok = "OK",
  Failed = "FAILED",
  Failing = "FAILING",
}
